import React, { useState } from "react";
import "../../styles/base/Card.css";

const Card = React.forwardRef(
  (
    {
      width = "250px",
      height = "auto",
      child,
      blurColor = "rgba(48,118,234,0.2)",
      onClick,
      "aria-label": ariaLabel,
      role,
      tabIndex,
    },
    ref
  ) => (
    <div
      className="card"
      style={{
        width: `${width}`,
        height: `${height}`,
        background: `radial-gradient(
                circle,
                rgba(255, 255, 255, 0.05) 0%,
                ${blurColor} 0%,
                rgba(255, 255, 255, 0.05) 70%
              )`,
        cursor: onClick ? "pointer" : "default",
      }}
      onClick={onClick}
      ref={ref}
      aria-label={ariaLabel}
      role={role || (onClick ? "button" : undefined)}
      tabIndex={tabIndex !== undefined ? tabIndex : (onClick ? 0 : undefined)}
      onKeyDown={onClick ? (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick(e);
        }
      } : undefined}
    >
      {child}
    </div>
  )
);
export default Card;
